import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ShopOrderPackagingView } from "src/components/views/erp/production/shopOrderPackaging/ShopOrderPackagingView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/shopOrderPackaging")({
	staticData: { title: i18n.t("shop_order_packaging"), legacyViewKey: "shopOrderPackagingPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ShopOrderPackagingView />;
}
